export const PROPERTY_DRAFT = "vacant";
export const PROPERTY_PUBLISHED = "published";
export const PROPERTY_RENTED = "occupied";
export const PROPERTY_DISABLED = "disabled";
export const PROPERTY_RESERVED = "reserved";
export const PROPERTY_ENABLED = "enable";
export const PROPERTY_BLOCKED = "blocked";


